const transitionReset = (...selectors: string[]) => {
	let resizeTimer: ReturnType<typeof setTimeout>

	// Collect ALL matching elements for every selector
	const targets: HTMLElement[] = []
	for (const sel of selectors) {
		if (!sel) continue
		targets.push(...Array.from(document.querySelectorAll<HTMLElement>(sel)))
	}

	window.addEventListener('resize', () => {
		// Kill transitions instantly so nothing flashes
		for (const el of targets) {
			el.style.transition = 'none'
		}

		// clear timeout throughout resize
		clearTimeout(resizeTimer)

		// After resize settles, remove the inline override
		// so the CSS stylesheet transitions take effect again
		resizeTimer = setTimeout(() => {
			for (const el of targets) {
				el.style.removeProperty('transition')
			}
		}, 250)
	})
}

export default transitionReset
